import axios from "./axios";

export async function fetchHolidays(params = {}) {
  try {
    const response = await axios.get("/holidays", { params });
    return response.data;
  } catch (error) {
    return error?.response?.data ?? { error: true };
  }
}

export function holidaysByEffectiveDate(holidays = []) {
  const map = new Map();
  (holidays || []).forEach((holiday) => {
    const key = holiday?.effective_date || holiday?.observed || holiday?.date;
    if (key) map.set(String(key).substring(0, 10), holiday);
  });
  return map;
}
